import type { CoachDto } from '@genoma/shared';

import { useI18n } from '../../i18n/index.tsx';
import { createCoach, fetchCoaches, inviteCoach } from '../../services/dashboard.service.ts';
import { useCan } from '../../stores/auth.store.ts';
import { StaffSection } from '../staff/StaffSection.tsx';

/**
 * The coaches on this programme.
 *
 * Admin manages; P&O reads. Reading it is part of running a cycle — knowing
 * who is coaching whom — while editing it is not, because an assignment is the
 * whole of what a coach can see and whoever edits the list can grant sight of
 * any leader's report.
 */
export const CoachesPage = () => {
  const { t } = useI18n();
  const canManage = useCan('coach:manage');

  return (
    <StaffSection<CoachDto>
      title={t('coaches.title')}
      subtitle={(count) => t('coaches.subtitle', { count })}
      emptyKey="coaches.none"
      newKey="coaches.new"
      helpKey="coaches.createHelp"
      footerKey={canManage ? 'coaches.footer' : 'coaches.footerReadOnly'}
      canManage={canManage}
      load={() => fetchCoaches().then((data) => data.coaches)}
      create={createCoach}
      invite={inviteCoach}
      href={(coach) => `/coaches/${coach.personId}`}
      extra={(coach) => (
        <span className="font-mono text-[11px] tracking-[0.06em] text-soft uppercase">
          {t('coaches.coacheeCount', { count: coach.coacheeCount })}
        </span>
      )}
    />
  );
};
